import type {LabelSize} from '@cypro/engine/database/schema'

/** Figma draws the label at 8 px = 1 mm; convert px to PDF points */
export const PX = 72 / 25.4 / 8

/**
 * One label size in Figma px (8 px = 1 mm). The standard layout is the 100 × 90 label of Figma section 12, the
 * compact one the 70 × 60 label of section 30 (CY-421); a new roll size is one more entry here.
 */
export interface LabelGeometry {
  layout: 'standard' | 'compact'
  page: {width: number; height: number}
  /** line: the divider on the band's right; lineInset: how far it stops short of the top and bottom */
  band: {width: number; line: number; lineInset: number; fontSize: number; letterSpacing: number; margin: number}
  body: {paddingX: number; paddingTop: number; paddingBottom: number}
  dataMatrix: number
  /** width of the patient text next to the Data Matrix */
  patientColumn: number
  /** page width minus the band and the body padding */
  bodyWidth: number
  /** characters of "substance dose" that fit one line at the regular heading size (CY-299) */
  headingOneLineMax: number
}

export const LABEL_SIZES: Record<LabelSize, LabelGeometry> = {
  SIZE_100X90: {
    layout: 'standard',
    page: {width: 800, height: 720},
    band: {width: 60, line: 2, lineInset: 0, fontSize: 28, letterSpacing: 6, margin: 20},
    body: {paddingX: 20, paddingTop: 14, paddingBottom: 12},
    dataMatrix: 120,
    patientColumn: 560,
    bodyWidth: 700,
    headingOneLineMax: 32,
  },
  SIZE_70X60: {
    layout: 'compact',
    page: {width: 560, height: 480},
    band: {width: 44, line: 2, lineInset: 16, fontSize: 22, letterSpacing: 4, margin: 16},
    body: {paddingX: 14, paddingTop: 12, paddingBottom: 10},
    // 9 mm; still open with Nick whether Krakow's scanners read it
    dataMatrix: 72,
    // body 488 minus the Data Matrix and a 12 px gap
    patientColumn: 404,
    bodyWidth: 488,
    // 32 × 488 / 700, rounded down
    headingOneLineMax: 22,
  },
}
